<template>
	<div>
		<Header :logo="`${imgPath}/static/assets/img/brand/6/logo.png`" :width="1.85" />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/brand/6/banner.jpg`" />
			<cloud />
		</div>
		<div class="brandWrap brand6" :class="{'zh-cn': lang=='zh-cn','en-us':lang == 'en-us'}">
			<div class="brandWrapModule" :class="{'zhw': lang=='zh-cn'}">
				<p :class="{'field_1 item_center': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_1"></p>
				<p :class="{'field_2 item_center': lang=='zh-cn', 'field_4':lang == 'en-us'}" style="margin-top: 0.6rem;" v-html="detail.field_2"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '0.41rem' : '0.455rem' }"><img :src="detail.field_3" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '2.04rem' : '1.255rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_4"></p>
				<p class="field_4" :style="{ 'marginTop': lang=='zh-cn'? '0.65rem' : '0.8rem' }" v-html="detail.field_5"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.02rem' : '1.205rem' }"><img :src="detail.field_6" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.31rem' : '1.685rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_7"></p>
				<p class="field_4" :style="{ 'marginTop': lang=='zh-cn'? '0.92rem' : '0.81rem' }" v-html="detail.field_8"></p>
			</div>
			<p class="brandImg_style2"><img :src="detail.field_9" width="100%" /></p>
			<div class="brandWrapModule" style="padding-left: 0.12rem" :style="{ 'marginTop': lang=='zh-cn'? '1.61rem' : '1.795rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" :style="{ 'width': lang=='zh-cn'? '100%' : '105%' }" v-html="detail.field_10"></p>
				<p class="field_4" :style="{ 'marginTop': lang=='zh-cn'? '0.76rem' : '0.7rem' }" v-html="detail.field_11"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '0.95rem' : '1.085rem' }"><img :src="detail.field_12" width="100%" /></p>
			<div class="brandWrapModule" style="padding-left: 0.12rem" :style="{ 'marginTop': lang=='zh-cn'? '1.4rem' : '1.325rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_13"></p>
				<p class="field_4" :style="{ 'marginTop': lang=='zh-cn'? '0.66rem' : '0.4rem' }" v-html="detail.field_14"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '0.62rem' : '1.165rem' }"><img :src="detail.field_15" width="100%" /></p>
			<a class="brandLinkWrap black" href="http://www.sancanal.com" target="_blank">
				<p class="brandLink1">{{ $t('shoplink') }}</p>
				<p class="brandLink2">www.sancanal.com</p>
				<img class="linkIcon" :src="`${imgPath}/static/assets/img/brand/linkImg1.png`" />
			</a>
			<top />
			<div class="cloudImg">
				<img :src="`${imgPath}/static/assets/img/cloud.png`" />
			</div>
			<bottom />
		</div>
	</div>
</template>
<script>
export default {
    data(){
		return{
			detail:{},
			lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
		}
	},
	async mounted() {
		let res = await this.$util.getBrandDetail(13)
		this.detail = res;
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/brandStyle.scss";
</style>


// WEBPACK FOOTER //
// src/views/brand/brand8.vue